// extracted by mini-css-extract-plugin
export var footer = "_pc-0";
export var inherit = "_pc-1";
export var input = "_pc-2";
export var modalContent = "_pc-3";
export var quillEditor = "_pc-4";
export var subtitle = "_pc-5";